import { Modal, message } from "antd"
import http from "@/http"
import { useTranslation } from "react-i18next";
import Store from "@/store"
import RegistrationGuideEn from "./Registration-Guide-en"
import RegistrationGuideKo from "./Registration-Guide-ko"
export default function RegistrationGuide() {

  const [modal, contextModalHolder] = Modal.useModal();
  const [messageApi, contextHolder] = message.useMessage();
  const { t } = useTranslation();
  const language = Store.getState().language
  const alertTip = () => {
    let mint = modal.confirm({
      className: "project-modal official-modal",
      title: null,
      width: "662px",
      content: (
        <div className="box">
          <h3 className="title text-center GmarketSans" style={{ fontSize: "30px", fontWeight: 700, color: "#2B2B2B" }} >
            {t('project.apply_for_project_registration')}
          </h3>
          <div
          >
            <div className="text-center" style={{ color: "#576059" }} dangerouslySetInnerHTML={{ __html: t('project.alertTips') }}>
            </div>
            <div className="cs-contact_form" style={{ marginTop: "30px" }}>
              <div className="row">
                <div className="col-lg-12">
                  <div className="title">{t('project.email')}</div>
                  <div className="cs-form_field_wrap">
                    <input
                      type="text"
                      id="email_input"
                      className="cs-form_field"
                      placeholder={t('project.email_tip')}
                    />
                  </div>
                  <div className="cs-height_20 cs-height_lg_20"></div>
                </div>
                <div className="col-lg-12">
                  <div className="title">
                    {t('project.project_overview')}
                  </div>
                  <div className="cs-form_field_wrap">
                    <textarea
                      cols="30"
                      rows="5"
                      id="content_input"
                      className="cs-form_field"
                      placeholder={t('project.project_overview_tip')}
                    ></textarea>
                  </div>
                  <div className="cs-height_20 cs-height_lg_20"></div>
                </div>

              </div>
            </div>
          </div>
        </div>
      ),
      footer: (
        <div
          className="d-flex gap-3 footer-btn-group mx-auto"
          style={{ maxWidth: "100%" }}
        >
          <button
            className="cs-btn cs-style1 cs-btn_lg flex-1 w-100 hollow"
            onClick={() => {
              mint.destroy();
            }}
          >
            <span>{t('common.cancel')}</span>
          </button>
          <button
            className="cs-btn cs-style1 cs-btn_lg flex-1 w-100"
            onClick={async () => {
              let email = document.getElementById("email_input").value,
                content = document.getElementById("content_input").value
              let emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
              if (!emailReg.test(email)) {
                messageApi.open({
                  type: "error",
                  content: t("register.input_email"),
                });
                return;
              }
              http.post('/system/NftRegistration', { email, content })
              mint.destroy();
            }}
          >
            <span>{t('common.submit')}</span>
          </button>

        </div >
      ),
    });
  }
  return <>
    {contextModalHolder}
    {contextHolder}
    {language == 'en' && <RegistrationGuideEn alertTip={alertTip} />}
    {language == 'ko' && <RegistrationGuideKo alertTip={alertTip} />}
  </>
}